/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Courses worth more credit hours represent more of your workload, so they count proportionally more toward your average.`)
};

const es_gpa_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las asignaturas con más créditos representan una mayor parte de tu carga de trabajo, así que cuentan proporcionalmente más en tu promedio.`)
};

const de_gpa_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurse mit mehr Kreditstunden machen einen größeren Teil deines Arbeitsaufwands aus und zählen daher anteilig stärker in deinen Durchschnitt.`)
};

const nl_gpa_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vakken met meer studiepunten vertegenwoordigen een groter deel van je studiebelasting, dus tellen ze evenredig zwaarder mee in je gemiddelde.`)
};

const fr_gpa_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les cours valant plus de crédits représentent une plus grande part de votre charge de travail, ils comptent donc proportionnellement plus dans votre moyenne.`)
};

const it_gpa_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I corsi che valgono più crediti rappresentano una parte maggiore del tuo carico di lavoro, quindi contano proporzionalmente di più nella media.`)
};

const pt_br2_gpa_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disciplinas com mais carga horária representam uma parte maior da sua carga de trabalho, então contam proporcionalmente mais na sua média.`)
};

const pt_gpa_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As disciplinas com mais horas de crédito representam mais carga de trabalho, por isso contam proporcionalmente mais para a sua média.`)
};

const ja_gpa_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単位数が多い科目はより多くの学習負荷を表すため、平均への寄与度もそれに応じて大きくなります。`)
};

const zh_gpa_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学分更高的课程代表更大的学习工作量，因此在平均分中所占的比重也应相应更大。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_faq_a3", locale)
	if (locale === "en") return en_gpa_faq_a3(inputs)
	if (locale === "es") return es_gpa_faq_a3(inputs)
	if (locale === "de") return de_gpa_faq_a3(inputs)
	if (locale === "nl") return nl_gpa_faq_a3(inputs)
	if (locale === "fr") return fr_gpa_faq_a3(inputs)
	if (locale === "it") return it_gpa_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_faq_a3(inputs)
	if (locale === "pt") return pt_gpa_faq_a3(inputs)
	if (locale === "ja") return ja_gpa_faq_a3(inputs)
	return zh_gpa_faq_a3(inputs)
};